<template>
  <div class="self-study">
    <titleBar :title="title"></titleBar>
    <div class="category" id="exercise" v-show="exercise.length > 0">
      <div class="header">
        <label class="title">跟着课本来练习</label>
      </div>
      <div class="exercise-list">
        <div v-for="(item, index) in exercise" :key="index" v-bind:class="exerciseStyle(index)">
          <img class="img" :src=item.img v-on:click="jumpToNative(item.jumpUrl)">
          <div class="mark" v-show="index == 0">免费试用</div>
          <img class="desc" v-on:click="jumpToNative(item.jumpUrl)">
          <p class="desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <div class="category" id="listen" v-show="listen.length > 0">
      <div class="header">
        <label class="title">大家都在听</label>
        <p class="btn" v-on:click="clickTotal('listen')">全部</p>
      </div>
      <div class="card-list">
        <div class="listen-card" v-for="(item, index) in listen" :key="index">
          <img class="img" :src=item.img v-on:click="jumpToNative(item.jumpUrl)">
          <img class="play-icon" src="../../assets/images/parent_active/listen_play_icon.png" v-on:click="jumpToNative(item.jumpUrl)">
          <p class="desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <div class="category" id="book" v-show="book.length > 0">
      <div class="header">
        <label class="title">畅游绘本世界</label>
      </div>
      <div class="card-list">
        <div class="medium-card" v-for="(item, index) in book" :key="index">
          <img class="img" :src=item.img v-on:click="jumpToNative(item.jumpUrl)">
          <p class="desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <div class="category" id="lite" v-show="lite.length > 0">
      <div class="header">
        <label class="title">每日轻课10分钟</label>
      </div>
      <div class="lesson-list">
        <div class="lesson" v-for="(item, index) in lite" :key="index" v-on:click="jumpToNative(item.jumpUrl)">
          <img class="img" :src=item.img>
          <div class="text">
            <p class="title">{{ item.title }}</p>
            <p class="desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="category" id="other" v-show="other.length > 0">
      <div class="header">
        <label class="title">边闯关边进步</label>
      </div>
      <div class="card-list">
        <div class="medium-card" v-for="(item, index) in other" :key="index">
          <img class="img" :src=item.img v-on:click="jumpToNative(item.jumpUrl)">
          <p class="desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <loading v-if="loading" :list="list" :loading="loading"></loading>
  </div>
</template>

<script>
import ajax from '@/api/studentAjax'
import utils from '@/assets/js/utils'
import titleBar from '@/components/common/fit_iphonex/titleBar_fit_iphonex.vue'
import loading from '@/components/common/loading.vue'
// import qs from 'qs'
export default {
  data() {
    return {
      title: '学习乐园',
      // banner: [],
      book: [], 
      listen: [],
      lite: [],
      exercise: [],
      other: [],
      loading: true,
      list: true,
    };
  },
  components: {
    titleBar,
    loading
  },
  methods: {
    getData: async function() {
      let token = utils.getQueryString("token")
      let source = utils.getQueryString('source')
      let version = utils.getQueryString('version')
      // let param = qs.parse(window.location.hash.substring(31))
      const [resp] = await ajax.all([
        ajax.get("/framework/index/get-home-page", {
          params: {
            token: token,
            source: source,
            version: version,
          }
          // params: param
        })
      ]);
      if (resp.data.code == 99999) {
        this.loading = false
        this.list = false
        // this.banner = resp.data.data.banner
        this.book = resp.data.data.book
        this.listen = resp.data.data.listen
        this.lite = resp.data.data.lite
        this.exercise = resp.data.data.exercise
        this.other = resp.data.data.other
      } else {
        this.loading = false
        this.list = false
      }
    },
    clickTotal: function(category) {
      if (category === 'listen') {
        location.href = "hybird://method/openBukeListeningHomePage"
      }
    },
    jumpToNative: function(url) {
      location.href = url;
    },
    exerciseStyle: function(index){
      return index==0?'big-card':'pure-small-card';
    }
  },
  created: async function() {       
    await this.getData()
  },
};
</script>

<style lang="scss" scoped>
.self-study {
  padding-top: .88rem;
  background: #fff;
  min-height: 100vh;
  padding-bottom: 1rem;
  .category {
    margin-top: .44rem;
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100px;
  }
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-left: .4rem;
    padding-right: .4rem;
    height: .8rem;
    align-items: center;
    .title {
      display: flex;
      font-family: PingFangSC-Semibold;
      font-size: .42rem;
      width: fit-content;
      color: #161616;
    }
    .btn {
      width: 1.2rem;
      height: 0.56rem;
      line-height: 0.5rem;
      text-align: center;
      font-family: PingFangSC-Medium;
      font-size: .24rem;
      color: #78797a;
      border-radius: .28rem;
      border: solid 2px #f3f3f3;
    }
  }
  .card-list {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-left: .4rem;
    padding-right: .4rem;
    .medium-card {
      display: flex;
      flex-direction: column;
      margin-top: .2rem;
      margin-bottom: 0.1rem;
      .img { 
        width: 3.24rem;
        height: 1.84rem;
        border-radius: .1rem;
      }
      .desc {
        margin-top: .15rem;
        font-family: PingFangSC-Medium;
        font-size: .28rem;
        width: 3.24rem;
        color: #4d4d4d;
        overflow: hidden;/*溢出隐藏*/
        text-overflow: ellipsis;/*文本溢出省略号*/
        white-space: nowrap;/*不换行*/
      }
    }
    .listen-card {
      display: flex;
      flex-direction: column;
      margin-top: .2rem;
      margin-bottom: 0.2rem;
      position: relative;
      .img { 
        width: 2.06rem;
        height: 2.06rem;
        border-radius: .1rem;
      }
      .play-icon {
        position: absolute;
        width: .44rem;
        height: .44rem;
        left: .1rem;
        top: 1.45rem;
        z-index: 2;
      }
      .desc {
        margin-top: .15rem;
        font-family: PingFangSC-Medium;
        font-size: .28rem;
        width: 2.06rem;
        color: #4d4d4d;
        overflow: hidden;/*溢出隐藏*/
        text-overflow: ellipsis;/*文本溢出省略号*/
        white-space: nowrap;/*不换行*/
      }
    }
  }
  .exercise-list{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-left: .4rem;
    padding-right: .4rem;
    .big-card {
      position: relative;
      display: flex;
      flex-direction: column;
      margin-top: .2rem;
      width: 100%;
      .img {
        width: 100%;
        border-radius: 0.1rem;
      }
      .mark {
        position: absolute;
        z-index: 10;
        top: 0;
        right: 0;
        width: 1.4rem;
        height: 0.5rem;
        background: #F5A623;
        text-align: center;
        line-height: 0.5rem;
        font-family: PingFangSC-Medium;
        font-size: 0.28rem;
        color: #fff;
      }
      .desc{
        margin-top: .15rem;
        margin-left: 0;
        margin-right: 0;
        font-family: PingFangSC-Medium;
        font-size: .28rem;
        color: #4d4d4d;
        overflow: hidden;/*溢出隐藏*/
        text-overflow: ellipsis;/*文本溢出省略号*/
        white-space: nowrap;/*不换行*/
      }
    }
    .pure-small-card {
      display: flex;
      flex-direction: column;
      margin-top: .34rem; 
      .img {
          width: 2.06rem;
          height: 2.06rem;
          border-radius: 0.1rem;
      }
      .desc{
        margin-top: .15rem;
        margin-left: 0;
        margin-right: 0;
        font-family: PingFangSC-Medium;
        width: 2.06rem;
        font-size: .28rem;
        color: #4d4d4d; 
        overflow: hidden;/*溢出隐藏*/
        text-overflow: ellipsis;/*文本溢出省略号*/
        white-space: nowrap;/*不换行*/

      }
    }
  }
  .lesson-list {
    display: flex;
    flex-direction: column;
    padding-left: .4rem;
    padding-right: .4rem;
    .lesson {
      display: flex;
      flex-direction: row;
      margin-top: .2rem;
      .img { 
        width: 2.04rem;
        height: 2.04rem;
        border-radius: .1rem;
      }
      .text {
        display: flex;
        flex-direction: column;
        margin-left: .2rem;
        .title {
          font-family: PingFangSC-Medium;
          font-size: .32rem;
          color: #424243;
          overflow: hidden;/*溢出隐藏*/
          text-overflow: ellipsis;/*文本溢出省略号*/
          white-space: nowrap;/*不换行*/
          margin-top: .2rem;
        }
        .desc {
          margin-top: .1rem;
          font-family: PingFangSC-Regular;
          font-size: .26rem;
          color: #919294;
          overflow: hidden;/*溢出隐藏*/
          text-overflow: ellipsis;/*文本溢出省略号*/
          white-space: nowrap;/*不换行*/
        }
      }
    }
  }
}
</style>